import {
  takeEvery,
  call,
  put,
  select,
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  searchSuccess,
  searchFail,
  customInventorySearchRequest,
  setCustomInventoryTripSearchParam,
} from '../../slices/tripSearch';
import { SearchStatus } from '../../../constants';
import { customInventorySearchSuccess, customInventorySearchTripId, updateCustomInventorySearchObj } from '../../slices/customInventory';

const queryString = require('query-string');

function* customInventorySearchWorker({ payload }) {
  try {
    const {
      startDate,
      endDate,
      destinations,
    } = yield select((store) => (payload.isTripSearch
      ? store.tripSearch.searchInputs.customInventory
      : store.customInventory?.customInventorySearches?.[payload.tripId]?.searchObj));

    const {
      travelAgency,
    } = yield select((store) => store.user);
    if (payload.isTripSearch) {
      yield put(setCustomInventoryTripSearchParam({
        ...payload,
        searchStatus: SearchStatus.SEARCHING,
      }));
    } else {
      updateCustomInventorySearchObj({
        ...payload, searchStatus: SearchStatus.SEARCHING,
      });
    }

    const query = {
      startDate,
      endDate,
      providerId: travelAgency && travelAgency.searchbarTab && travelAgency.searchbarTab.id,
      destinations: _.map(destinations, 'label'),
    };
    const qs = queryString.stringify(query, { skipNull: true });
    const url = `/inventory/search?${qs}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (payload.isTripSearch) {
      yield put(searchSuccess(data));
    } else {
      yield put(customInventorySearchSuccess({
        response: data,
        tripId: payload.tripId,
        queryString: qs,
      }));
    }
  } catch (error) {
    console.log(error);
    yield put(searchFail(error));
  }
}

function* customInventorySearchWatcher() {
  yield takeEvery(customInventorySearchRequest.toString(), customInventorySearchWorker);
  yield takeEvery(customInventorySearchTripId.toString(), customInventorySearchWorker);
}

export default customInventorySearchWatcher;
